module.exports = __webpack_public_path__ + "stokke_round-a22c8db25c24a9e37e0dbdee4491c3a6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/stokke_round.png
// module id = 1189
// module chunks = 1 2